import React, { useContext } from 'react';
import { Field } from 'react-final-form';
import InputField from 'components/InputField';
import { useTranslation } from 'react-i18next';
import useValidations from 'router/subrouters/Auth/hooks/useValidations';
import PasswordField from 'components/PasswordField';
import ReCAPTCHA from 'react-google-recaptcha';
import env from 'env';
import VendorQualificationsContext from 'providers/VendorQualification/VendorQualifications.context';
import utils from '../../../../../utils';
import ContactNumberField from 'components/ContactNumberField';
import EmailField from 'components/EmailField';

import './SignupField.styles.scss';
import './SignupField.styles.responsive.scss';

const SignupField: React.FC = () => {
  const { t } = useTranslation();

  const commonValidations = useValidations();

  const { recaptchaRef } = useContext(VendorQualificationsContext);

  return (
    <div className="signup-field">
      <Field
        name="firstName"
        label={t('firstName')}
        component={InputField}
        validate={commonValidations.name}
        required
      />
      <Field
        name="lastName"
        label={t('lastName')}
        component={InputField}
        validate={commonValidations.name}
        required
      />
      <ContactNumberField required />
      <EmailField required />
      <Field
        name="password"
        label={t('password')}
        component={PasswordField}
        validate={commonValidations.password}
        required
      />

      {!utils.isSSG() && (
        <ReCAPTCHA
          className="recaptcha"
          ref={recaptchaRef}
          sitekey={env.ReCAPTCHA_KEY}
        />
      )}
    </div>
  );
};

export default SignupField;
